/**
 * Company Search — warm path (sealed element c, annotation 4).
 *
 * Card label is exactly "Warm path". Renders the single warm_path name the
 * contract provides (name only; null permitted → honest "None on record").
 * Carrier-vs-fallback status is NEVER shown — the profile contract exposes no
 * such flag, and disclosing it is forbidden. The introduction request is
 * disabled-honest until Slice C ships the server-side action.
 */

import { IconWarmPath } from "./icons";

export function WarmPathCard({ warmPath }: { warmPath: string | null }): JSX.Element {
  return (
    <section className="sxco-card">
      <p className="sxco-card-head">
        <span className="sxco-card-icon" aria-hidden="true">
          <IconWarmPath />
        </span>
        Warm path
      </p>
      {warmPath ? (
        <div className="sxco-warm-person">
          <span className="sxco-warm-name">{warmPath}</span>
        </div>
      ) : (
        <p className="sxco-muted">None on record.</p>
      )}
      <button
        type="button"
        className="sx-btn sx-btn-p3 sxco-card-action"
        disabled
        aria-disabled="true"
        title="Introduction requests arrive in a later slice"
      >
        Request introduction
      </button>
      <p className="sxco-hint">Introduction requests are not yet available.</p>
    </section>
  );
}
